module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "Cory_Frazier.0248e32d.webp";